import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../app.settings';
import {
  TributeInfoActions,
  TributeInfo
} from '../transaction-store/tribute-info';
import { Store, Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { GaClient } from '../../init';

class Tribute {
  id: string;
  description: string;
  image_url: string;
}

@Component({
  selector: 'app-tribute',
  template: `
    <section>
      <div>
        <h2 class="section-title col">Your Tribute</h2>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-5">
            <button
              *ngIf="!selectedGift"
              type="button"
              class="btn btn-outline-secondary w-100"
              (click)="open(content)"
            >
              Select Your Tribute
            </button>
            <div
              *ngIf="selectedGift"
              (click)="open(content)"
              class="choose-type-image h-100"
              [ngStyle]="{
                'background-image': 'url(' + selectedGift.image_url + ')'
              }"
            ></div>
          </div>
        </div>
      </div>
    </section>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="modal-header d-block text-center container" *ngIf="step == 0">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row">
          <h2 id="tributeModalTitle" class="col-12 text-center">
            Choose Your Tribute Type
          </h2>
          <p class="col-12">{{ subtitle }}</p>
        </div>
      </div>
      <div class="modal-body container" *ngIf="step == 0">
        <div class="row">
          <div
            class="col-12 col-sm choose-type align-center text-center"
            *ngFor="let item of tributeList"
          >
            <label
              class="h-100"
              tabindex="0"
              role="button"
              [ngClass]="item.id == (selected ? 'active-gift' : '')"
            >
              <div
                class="choose-type-image h-100"
                [ngStyle]="{
                  'background-image': 'url(' + item.image_url + ')'
                }"
              ></div>
              <p class="text-center choose-type-title">
                {{ item.description }}
              </p>
              <input
                type="radio"
                name="gift"
                [value]="item.id"
                id="gift"
                hidden
                [(ngModel)]="selected"
                (ngModelChange)="setGift(item)"
              />
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col text-center form-group">
            <button
              type="submit"
              class="btn btn-secondary"
              (click)="step = 1"
              [disabled]="!selected"
            >
              Continue
            </button>
            <span id="thankyou-skip"
              >&nbsp;&nbsp;&nbsp;or
              <a (click)="clear(d)"><strong>No Thanks</strong></a></span
            >
          </div>
        </div>
      </div>
      <div class="modal-header d-block text-center container" *ngIf="step == 1">
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="d('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="row">
          <h2 id="tributeModalTitle" class="col-12 text-center">
            Customize Your Tribute
          </h2>
        </div>
      </div>
      <div class="modal-body container" *ngIf="step == 1">
        <div class="row">
          <div class="col-12 text-center">
            <h3>Tribute Message</h3>
          </div>
        </div>
        <div class="collapsed-form mb-3">
          <div class="form-group row">
            <text-field
              class="col"
              label="From"
              [showValidation]="validate"
              [required]="true"
              [(ngModel)]="internalTributeInfo.from"
            ></text-field>
          </div>
        </div>
        <div
          class="collapsed-form mb-3"
          *ngFor="let honoree of internalTributeInfo.honorees; let i = index"
        >
          <div class="form-group row">
            <text-field
              class="col-12 col-sm"
              label="Honoree First Name"
              [showValidation]="validate"
              [required]="selectedGift.recipient_name_required"
              [(ngModel)]="internalTributeInfo.honorees[i].firstname"
            >
            </text-field>
            <text-field
              class="col-12 col-sm"
              label="Honoree Last Name"
              [showValidation]="validate"
              [required]="selectedGift.recipient_name_required"
              [(ngModel)]="internalTributeInfo.honorees[i].lastname"
            >
            </text-field>
          </div>
          <div class="form-group row" *ngIf="!selectedGift.remove_message">
            <text-field
              class="col"
              label="Message"
              [showValidation]="validate"
              [required]="selectedGift.message_required"
              [(ngModel)]="internalTributeInfo.honorees[i].message"
            ></text-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <a
              class="float-right add-designation"
              (click)="addHonoree()"
              aria-label="Add another honoree"
              >Add Honoree</a
            >
          </div>
        </div>
        <div class="row" *ngIf="!selectedGift.remove_tribute_send">
          <div class="col text-center">
            <h3>Please send the tribute to:</h3>
          </div>
        </div>
        <address-block
          *ngIf="!selectedGift.remove_tribute_send"
          [showValidation]="validate"
          (blur)="onAddressBlur($event)"
          [international]="international"
          [optional]="!selectedGift.recipient_address_required"
          [requireEmail]="selectedGift.recipient_email_required"
          [addressSource]="internalTributeInfo"
        ></address-block>
        <div class="row">
          <div class="col text-center form-group">
            <button type="submit" class="btn btn-secondary" (click)="give(c)">
              Continue
            </button>
            <span id="thankyou-skip"
              >&nbsp;&nbsp;&nbsp;or
              <a (click)="clear(d)"><strong>No Thanks</strong></a></span
            >
          </div>
        </div>
      </div>
    </ng-template>
  `
})
export class TributeComponent {
  @Select() tributeInfo$: Observable<TributeInfo>;

  closeResult: string;
  tributeList: Tribute[];
  selected = null;
  selectedGift = null;
  step = 0;
  international = true;
  subtitle = '';
  validate = false;
  internalTributeInfo: TributeInfo = new TributeInfo();

  constructor(
    private modalService: NgbModal,
    private settings: AppSettings,
    private store: Store
  ) {
    const campaign = this.settings.getValue('organization').campaign;
    if (campaign) {
      this.tributeList = campaign.tribute_definitions;
    }
    this.subtitle = this.settings.getValue('properties').tribute_summary;

    this.tributeInfo$.subscribe(info => {
      // tribute modal submits entire updates at once, when modal is submitted
      // this is a legitimate use for internal state - keep it synchronized, though.
      Object.assign(this.internalTributeInfo, info);
    });
  }
  open(content: any) {
    this.step = 0;
    this.modalService.open(content, { size: 'lg' }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.internalTributeInfo = new TributeInfo();
        this.store.dispatch(
          new TributeInfoActions.SetTributeInfo(this.internalTributeInfo)
        );
        this.store.dispatch(new TributeInfoActions.SetTributeCompleted(false));
        this.closeResult = `Dismissed`;
        this.selectedGift = null;
        this.selected = null;
        this.step = 0;
      }
    );
  }
  setGift(item: Tribute) {
    this.selectedGift = item;
    this.store.dispatch(new TributeInfoActions.SetTributeID(item.id));
  }
  clear(dismiss) {
    // this doesn't empty out the tribute info, but effectively makes it so
    // it won't be posted to gmsnext if a donor backs out
    this.selectedGift = null;
    this.store.dispatch(new TributeInfoActions.SetTributeID(null));
    this.store.dispatch(new TributeInfoActions.SetTributeCompleted(null));
    dismiss();
  }
  onAddressBlur($event: { name: string; value: any }) {
    this.internalTributeInfo[$event.name] = $event.value;
  }
  addHonoree() {
    validateHonorees(this.internalTributeInfo.honorees) &&
      this.internalTributeInfo.honorees.push({
        firstname: '',
        lastname: '',
        message: ''
      });
  }
  give(close) {
    this.validate = true;
    let validation =
      this.selectedGift.remove_message ||
      !this.selectedGift.message_required ||
      validateMessage(this.internalTributeInfo);
    validation =
      validation &&
      (!this.selectedGift.recipient_name_required ||
        validateName(this.internalTributeInfo));
    validation =
      validation &&
      (this.selectedGift.remove_tribute_send ||
        !this.selectedGift.recipient_address_required ||
        validateAddress(this.internalTributeInfo));
    validation =
      validation &&
      (this.selectedGift.remove_tribute_send ||
        !this.selectedGift.recipient_email_required ||
        validateEmail(this.internalTributeInfo));
    validation = validation && this.internalTributeInfo.from != '';
    if (validation) {
      GaClient.trackFieldAction('Tribute Chosen');
      this.internalTributeInfo.honorees = this.internalTributeInfo.honorees.filter(
        item => item.firstname || item.lastname || item.message
      );
      this.store.dispatch(
        new TributeInfoActions.SetTributeInfo(this.internalTributeInfo)
      );
      this.store.dispatch(new TributeInfoActions.SetTributeCompleted(true));
      close();
    }
  }
}

function validateHonorees(
  honorees: { firstname: string; lastname: string; message: string }[]
) {
  return (
    honorees.filter(item => !(item.firstname || item.lastname || item.message))
      .length === 0
  );
}

function validateAddress(info) {
  return (
    !!info.firstName &&
    !!info.lastName &&
    !!info.address1 &&
    !!info.city &&
    !!info.state &&
    !!info.zip
  );
}
function validateName(info) {
  return (
    info.honorees.filter(item => !item.firstname || !item.lastname).length === 0
  );
}
function validateMessage(info) {
  return info.honorees.filter(item => !item.message).length === 0;
}
function validateEmail(info) {
  return !!info.email;
}
